/** `18:00` -> `06:00 pm`. Values already carrying an am/pm period are returned untouched. */
export const to12Hour = (time: string): string => {
	if (/[ap]m/i.test(time)) return time;
	const [hoursRaw, minutes] = time.split(':');
	const hours = Number.parseInt(hoursRaw, 10);
	if (Number.isNaN(hours) || minutes === undefined) return time;
	const period = hours >= 12 ? 'pm' : 'am';
	const normalizedHours = hours % 12 === 0 ? 12 : hours % 12;
	return `${String(normalizedHours).padStart(2, '0')}:${minutes} ${period}`;
};

/**
 * Checks whether the current time is before the specified cutoff time.
 *
 * @param cutoffTime - The cutoff time in HH:mm format (e.g., "14:30").
 * @returns true if the current time is before the cutoff time; otherwise, false.
 */
export const isBeforeCutoff = (cutoffTime: string): boolean => {
	if (!cutoffTime) return false;

	const now = new Date();
	const [cutoffHours, cutoffMinutes] = cutoffTime.split(':').map(Number);

	const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

	const cutoffSeconds = cutoffHours * 3600 + cutoffMinutes * 60;

	return currentSeconds < cutoffSeconds;
};
